import { gql } from "@apollo/client";

export const CREATE_ADMIN_USER = gql`
  mutation CreateAdminUser($input: CreateAdminUserInput!) {
    createAdminUser(input: $input)
  }
`;

export const EDIT_ADMIN_USER = gql`
  mutation EditAdminUser($input: EditAdminUserInput!) {
    editAdminUser(input: $input)
  }
`;

export const DELETE_ADMIN = gql`
  mutation DeleteAdmin($id: Int!) {
    deleteAdmin(id: $id)
  }
`;

export const CREATE_INSURANCE_COMPANY = gql`
  mutation CreateInsuranceCompany($input: CreateInsuranceCompanyInput!) {
    createInsuranceCompany(input: $input)
  }
`;

export const RESET_PROGRESS = gql`
  mutation ResetProgress($input: ProgressResetInput!) {
    resetProgress(input: $input) {
      id
      projectId
      goal
      approved
      remarks
      title
      description
      completed
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_PROJECT = gql`
  mutation DeleteProject($id: Int!) {
    deleteProject(id: $id)
  }
`;

export const CREATE_LEAD = gql`
  mutation CreateLead($input: CreateLeadInput!) {
    createLead(input: $input) {
      leadId
    }
  }
`;

export const CREATE_ADDRESS = gql`
  mutation CreateAddress($input: AddressInput!) {
    createAddress(input: $input) {
      id
      success
    }
  }
`;

export const CREATE_PROJECT = gql`
  mutation createProject($input: ProjectInput!) {
    createProject(input: $input) {
      id
      projectRefNumber
    }
  }
`;

export const SEND_ROUGH_ESTIMATE_TO_USER = gql`
  mutation SendRoughEstimateToUser($input: RoughEstimateInput!) {
    SendRoughEstimateToUser(input: $input)
  }
`;

export const EDIT_INSURANCE_COMPANY = gql`
  mutation EditInsuranceCompany(
    $id: Int!
    $input: CreateInsuranceCompanyInput!
  ) {
    editInsuranceCompany(id: $id, input: $input)
  }
`;

export const DELETE_INSURANCE_COMPANY_BY_ID = gql`
  mutation DeleteInsuranceCompany($id: Int!) {
    deleteInsuranceCompany(id: $id)
  }
`;

export const CREATE_MATERIAL = gql`
  mutation CreateMaterial($input: CreateMaterialInput!) {
    createMaterial(input: $input)
  }
`;

export const UPDATE_MATERIAL = gql`
  mutation UpdateMaterial($input: UpdateMaterialInput!) {
    updateMaterial(input: $input)
  }
`;

export const CREATE_UPLOAD_URL = gql`
  mutation CreateUploadUrl($input: UploadFileInput!) {
    createUploadUrl(input: $input) {
      url
      fileName
    }
  }
`;

export const APPROVE_SCOPE_MUTATION = gql`
  mutation ApproveScope($input: scopeApprovalInput!) {
    approveScope(input: $input)
  }
`;

export const ADD_PROJECT_MATERIAL_MEASUREMENT = gql`
  mutation AddProjectMaterialMeasurement($input: [ProjectMeasurementInput]!) {
    addProjectMaterialMeasurement(input: $input)
  }
`;

export const CREATE_PAYMENT_MUTATION = gql`
  mutation CreatePayment($input: PaymentInput!) {
    createPayment(input: $input) {
      token
    }
  }
`;

export const CREATE_PROJECT_FILE = gql`
  mutation CreateProjectFile($input: createProjectFileInput!) {
    createProjectFile(input: $input)
  }
`;

export const DELETE_COC_IMAGE = gql`
  mutation DeleteCocImage($fileId: Int!, $projectId: Int!) {
    deleteCocImage(fileId: $fileId, projectId: $projectId)
  }
`;

export const SAVE_COC_IMAGE_ORDER = gql`
  mutation SaveCoCImageOrder($input: SaveCoCImageOrderInput!) {
    saveCoCImageOrder(input: $input)
  }
`;

export const GENERATE_COC = gql`
  mutation GenerateCertificateOfCompletion($input: GenerateCoCInput!) {
    generateCertificateOfCompletion(input: $input)
  }
`;

export const UPDATE_PROJECT_FILE = gql`
  mutation UpdateProjectFile($input: updateProjectFileInput!) {
    updateProjectFile(input: $input)
  }
`;

export const CREATE_PROJECT_MATERIAL_MEASUREMENT = gql`
  mutation AddProjectMaterialMeasurement($input: [ProjectMeasurementInput]!) {
    addProjectMaterialMeasurement(input: $input)
  }
`;

export const CREATE_PROJECT_LABOR_MEASUREMENT = gql`
  mutation AddProjectLaborMeasurement($input: [ProjectMeasurementInput]!) {
    addProjectLaborMeasurement(input: $input)
  }
`;

export const CREATE_PROJECT_ADDON = gql`
  mutation AddProjectAddOns($input: CreateAddOnsInput!) {
    addProjectAddOns(input: $input)
  }
`;

export const EDIT_PROJECT_ADDON = gql`
  mutation EditProjectAddOns($input: EditAddOnsInput!) {
    editProjectAddOns(input: $input)
  }
`;

export const ADD_CLAIM_DETAILS = gql`
  mutation AddClaimDetails($input: AddClaimInput!) {
    addClaimDetails(input: $input)
  }
`;

export const DELETE_PROJECT_ADDON = gql`
  mutation deleteProjectAddOns($addOnId: Int!) {
    deleteProjectAddOns(addOnId: $addOnId)
  }
`;

export const CREATE_INVOICE = gql`
  mutation CreateInvoice($input: CreateInvoiceInput!) {
    createInvoice(input: $input)
  }
`;

export const UPDATE_INVOICE = gql`
  mutation UpdateInvoice($input: UpdateInvoiceInput!) {
    updateInvoice(input: $input)
  }
`;

export const SET_NEW_PASSWORD_MUTATION = gql`
  mutation setAdminPassword($input: NewPasswordInput!) {
    setAdminPassword(input: $input)
  }
`;

export const CREATE_ACCOUNT = gql`
  mutation CreateAccount($input: CreateCustomerInput!) {
    createAccount(input: $input) {
      token
      projectId
      projectRefNumber
    }
  }
`;

export const EDIT_CUSTOMER = gql`
  mutation EditCustomer($input: EditCustomer!) {
    editCustomer(input: $input) {
      id
      firstName
      lastName
      email
      phone
      address {
        id
        street
        city
        state
        zipCode
        lat
        lng
      }
    }
  }
`;

export const UPDATE_PAYMENT_METHOD = gql`
  mutation UpdatePaymentMethod($input: PaymentMethodUpdateInput!) {
    updatePaymentMethod(input: $input)
  }
`;

export const ADD_YOUR_NEW_PROVIDER = gql`
  mutation AddYourNewProvider($input: newProviderInput!) {
    addYourProvider(input: $input)
  }
`;

export const SELECT_MATERIAL = gql`
  mutation SelectMaterial($input: SelectMaterialInput!) {
    selectMaterial(input: $input)
  }
`;

export const MATERIAL_QUALITY = gql`
  mutation preferredMaterialQuality($input: PreferredMaterialQualityInput!) {
    preferredMaterialQuality(input: $input)
  }
`;

export const SELECT_CONTRACTOR = gql`
  mutation SelectContractor($input: SelectContractorInput!) {
    selectContractor(input: $input)
  }
`;

export const SELECT_INSTALLATION_DATE = gql`
  mutation SelectInstallation($input: InstallationInput!) {
    selectInstallation(input: $input)
  }
`;

export const ARCHIVE_PROJECT = gql`
  mutation ArchiveProject($pId: Int!, $reason: ArchiveReason!, $customReason: String, $archive: Boolean!) {
    ArchiveProject(pId: $pId, reason: $reason, customReason: $customReason, archive: $archive)
  }
`;

export const ARCHIVE_PROJECT_FILE = gql`
  mutation ArchiveProjectFile($pId: Int!, $fId: Int!) {
    ArchiveProjectFile(pId: $pId, fId: $fId)
  }
`;

export const CREATE_PROJECT_PAYMENT_ADMIN = gql`
  mutation CreateProjectPaymentAdmin($input: projectPaymentAdmin!) {
    createProjectPaymentAdmin(input: $input)
  }
`;

export const UPDATE_PROJECT_PAYMENT_ADMIN = gql`
  mutation UpdateProjectPaymentAdmin($input: UpdateProjectPaymentAdmin!) {
    updateProjectPaymentAdmin(input: $input)
  }
`;

export const UPDATE_ORDER_STATUS = gql`
  mutation UpdateProjectProductSystemOrderStatus($input: ProjectProductSystemOrderStatusInput!) {
    UpdateProjectProductSystemOrderStatus(input: $input)
  }
`;

export const UPDATE_PROGRESS = gql`
  mutation UpdateProgress($input: UpdateProgressInput!) {
    updateProgress(input: $input) {
      id
      step
      projectId
      title
      description
      remarks
      approved
      completed
      createdAt
      updatedAt
    }
  }
`;

export const ASSIGN_ROLE_TO_PROJECT = gql`
  mutation AssignRoleToProject($input: AssignToProject!) {
    AssignRoleToProject(input: $input)
  }
`;

export const CREATE_TEMPLATE = gql`
  mutation createTemplate($input: [TemplateInput!]!) {
    createTemplate(input: $input)
  }
`;

export const UPLOAD_MERGED_INVOICE = gql`
  mutation UploadMergedInvoice($projId: Int!, $url: String!) {
    UploadMergedInvoice(projId: $projId, url: $url)
  }
`;

export const SEND_INVOICE_EMAIL = gql`
  mutation SendInvoiceEmail($input: invoiceEmail!) {
    sendInvoiceEmail(input: $input)
  }
`;

export const CREATE_SUPPLIER = gql`
  mutation CreateSupplier($input: inputCreateSupplier!) {
    createSupplier(input: $input)
  }
`;

export const UPDATE_SUPPLIER = gql`
  mutation UpdateSupplier($input: inputUpdateSupplier!) {
    updateSupplier(input: $input)
  }
`;

export const ARCHIVE_SUPPLIER = gql`
  mutation ArchiveSupplier($id: Int!) {
    archiveSupplier(id: $id)
  }
`;

export const GET_AFFIDAVIT_SIGNING_URL = gql`
  mutation GetAffidavitSigningUrl($input: AffidavitFields!) {
    getAffidavitSigningUrl(input: $input)
  }
`;

export const UPDATE_STAGE_STATUS = gql`
  mutation UpdateStageStatus($projectId: Int!, $stage: ProjectStage!, $completed: Boolean!) {
    UpdateStageStatus(projectId: $projectId, stage: $stage, completed: $completed)
  }
`;

export const SELECT_LABOR_VARIANT = gql`
  mutation SelectLaborVariant($input: SelectLaborVariantInput!) {
    SelectLaborVariant(input: $input)
  }
`;